export default class Plan {
	constructor({
		id,
		name,
		description,
		quantity,
		interval,
		price
	} = {}) {
		this._id = id || null;
		this._name = name || null;
		this._description = description || null;
		this._quantity = quantity || 0;
		this._interval = interval || null;
		this._price = price || null;
	}

	getId() {
		return this._id;
	}

	getKey() {
		return String(this._id);
	}

	getName() {
		return this._name;
	}

	getDescription() {
		return this._description;
	}

	getQuantity() {
		return this._quantity;
	}

	getInterval() {
		return this._interval;
	}

	getPrice() {
		return this._price;
	}

}
